import { createContext, useContext, useState, useMemo, useCallback } from 'react';
import { translations } from '../translations';

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    const param = new URLSearchParams(window.location.search).get('lang');
    return ['en', 'ru', 'bg'].includes(param) ? param : 'en';
  }); // 'en', 'ru', or 'bg' (auto-selected via ?lang= URL param)

  const toggleLanguage = useCallback(() => {
    setLanguage(prev => {
      if (prev === 'en') return 'ru';
      if (prev === 'ru') return 'bg';
      return 'en';
    });
  }, []);

  const t = useCallback((key) => {
    const keys = key.split('.');
    let value = translations[language];
    for (const k of keys) {
      value = value?.[k];
    }
    return value || key;
  }, [language]);

  const value = useMemo(
    () => ({ language, toggleLanguage, t }),
    [language, toggleLanguage, t]
  );

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};
